import { createApp } from 'vue'

import Cookies from 'js-cookie'

import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'dayjs/locale/zh-cn';// 中文语言
import { dayjs } from 'element-plus';
import '@/assets/styles/index.scss' // global css
import '@/utils/print.min.js'
import App from './App'
import store from './store'
import router from './router'
import directive from './directive' // directive

// 注册指令
import plugins from './plugins' // plugins
import { download } from '@/utils/request'

// svg图标
import 'virtual:svg-icons-register'
import SvgIcon from '@/components/SvgIcon'
import elementIcons from '@/components/SvgIcon/svgicon'

import './permission' // permission control

import { useDict } from '@/utils/dict'
import * as platform from '@/utils/platform'
import { parseTime, resetForm, addDateRange, handleTree, selectDictLabel, selectDictLabels, selectDictLabelProxy } from '@/utils/ruoyi'

// 分页组件
import Pagination from '@/components/Pagination'
// 自定义表格工具组件
import RightToolbar from '@/components/RightToolbar'
// 富文本组件
import Editor from "@/components/Editor"
// 文件上传组件
import FileUpload from "@/components/FileUpload"
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
// 自定义树选择组件
import TreeSelect from '@/components/TreeSelect'
// 字典标签组件
import DictTag from '@/components/DictTag'
//校区级联选择器
import SchoolCascader from '@/components/schoolCascader'
//日期增强
import DateRangePicker from '@/components/EnhanceForm/DateRangePicker'
//手机号/身份证/微信号隐藏
import hideNum from '@/components/hideNum';
// 右侧区域自适应布局
import MainLayout from '@/components/Layout/main'
// 搜索区域布局
import SearchLayout from '@/components/Layout/search'
//注册全局echarts
import ECharts from 'vue-echarts';
import 'echarts';

import 'virtual:svg-icons-register'
//vxeTable
import 'xe-utils'
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
// ...可选 UI
import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
// vant
import '@vant/touch-emulator';
// import animated from 'animate.css';
function useTable (app) {
  app.use(VXETable).use(VxeUI)
}
const app = createApp(App)

// 全局方法挂载
app.config.globalProperties.useDict = useDict
app.config.globalProperties.download = download
app.config.globalProperties.parseTime = parseTime
app.config.globalProperties.resetForm = resetForm
app.config.globalProperties.handleTree = handleTree
app.config.globalProperties.addDateRange = addDateRange
app.config.globalProperties.selectDictLabel = selectDictLabel
app.config.globalProperties.selectDictLabels = selectDictLabels
app.config.globalProperties.selectDictLabelProxy = selectDictLabelProxy
app.config.globalProperties.platform = platform

// 全局组件挂载
app.component('DictTag', DictTag)
app.component('Pagination', Pagination)
app.component('TreeSelect', TreeSelect)
app.component('FileUpload', FileUpload)
app.component('ImageUpload', ImageUpload)
app.component('ImagePreview', ImagePreview)
app.component('RightToolbar', RightToolbar)
app.component('Editor', Editor)
app.component('v-chart', ECharts);
app.component('schoolCascader', SchoolCascader)
app.component('DateRangePicker', DateRangePicker)
app.component('MainLayout', MainLayout)
app.component('SearchLayout', SearchLayout)
app.component('hideNum', hideNum)


app.use(router)
app.use(store)
app.use(plugins)
app.use(elementIcons)
app.use(useTable)
// app.use(animated)
app.component('svg-icon', SvgIcon)

directive(app)

// 使用element-plus 并且设置全局的大小
app.use(ElementPlus, {
  locale: zhCn,
  // 支持 large、default、small
  size: Cookies.get('size') || 'default'
})
dayjs.locale('zh-cn')
app.mount('#app')
